import TicketChartsByMonth from './TicketChartsByMonth';
import TicketsChartsByCommonReason from './TicketsChartsByCommonReason';
import TicketChartsByStatus from './TicketChartsByStatus';
import TicketChartsByType from './TicketChartsByType';
import TicketsWithLinkedEntities from './TicketsWithLinkedEntities';

export default function TicketCharts() {
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2">
        <h1 className="text-xl font-semibold text-coal-900">Ticket Analytics</h1>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <TicketChartsByStatus />
        <TicketChartsByMonth />
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <TicketsChartsByCommonReason />
        <TicketChartsByType />
      </div>

      <TicketsWithLinkedEntities />
    </div>
  );
}
